import { Route, Routes } from 'react-router-dom'
import ScrollToTop from './components/site/ScrollToTop'
import SiteLayout from './components/site/SiteLayout'
import HomePage from './pages/HomePage'
import MissionHomePage from './pages/MissionHomePage'
import AboutPage from './pages/AboutPage'
import CreditsPage from './pages/CreditsPage'
import LicensePage from './pages/LicensePage'
import PrivacyPage from './pages/PrivacyPage'
import AccessibilityPage from './pages/AccessibilityPage'
import DisclaimerPage from './pages/DisclaimerPage'
import GettingStartedPage from './pages/GettingStartedPage'
import FoundationsPage from './pages/FoundationsPage'
import PatternsPage from './pages/PatternsPage'
import PatternDetailPage from './pages/PatternDetailPage'
import AgentsPage from './pages/AgentsPage'
import ComponentsPage from './pages/ComponentsPage'
import ComponentDetailPage from './pages/ComponentDetailPage'
import MissionsPage from './pages/MissionsPage'
import MissionDetailPage from './pages/MissionDetailPage'
import ColorPage from './pages/foundations/ColorPage'
import TypographyPage from './pages/foundations/TypographyPage'
import ShapePage from './pages/foundations/ShapePage'
import LayoutPage from './pages/foundations/LayoutPage'
import MotionPage from './pages/foundations/MotionPage'
import IdentityPage from './pages/foundations/IdentityPage'
import SearchPage from './pages/SearchPage'
import NotFoundPage from './pages/NotFoundPage'
import TemplatesPage from './pages/TemplatesPage'
import DesignToolsPage from './pages/DesignToolsPage'
import SpecSheetPage from './pages/SpecSheetPage'
import TemplateDetailPage from './pages/TemplateDetailPage'
import TemplatePreviewPage from './pages/TemplatePreviewPage'
import { PrefsProvider } from './state/PrefsProvider'
export default function App() {
  return (
    <PrefsProvider>
      <ScrollToTop />
      <Routes>
        {/* A template preview is a whole page of its own, without the site's frame. */}
        <Route path="/templates/:slug/preview" element={<TemplatePreviewPage />} />
        <Route path="/design-tools/spec" element={<SpecSheetPage />} />
        <Route element={<SiteLayout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/getting-started" element={<GettingStartedPage />} />
          <Route path="/design-tools" element={<DesignToolsPage />} />
          <Route path="/foundations" element={<FoundationsPage />} />
          <Route path="/foundations/color" element={<ColorPage />} />
          <Route path="/foundations/typography" element={<TypographyPage />} />
          <Route path="/foundations/layout" element={<LayoutPage />} />
          <Route path="/foundations/shape" element={<ShapePage />} />
          <Route path="/foundations/motion" element={<MotionPage />} />
          <Route path="/foundations/identity" element={<IdentityPage />} />
          <Route path="/components" element={<ComponentsPage />} />
          <Route path="/components/:slug" element={<ComponentDetailPage />} />
          <Route path="/missions" element={<MissionsPage />} />
          <Route path="/missions/:slug" element={<MissionDetailPage />} />
          <Route path="/templates" element={<TemplatesPage />} />
          <Route path="/templates/:slug" element={<TemplateDetailPage />} />
          <Route path="/patterns" element={<PatternsPage />} />
          <Route path="/patterns/:slug" element={<PatternDetailPage />} />
          <Route path="/agents" element={<AgentsPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/credits" element={<CreditsPage />} />
          <Route path="/license" element={<LicensePage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/accessibility" element={<AccessibilityPage />} />
          <Route path="/disclaimer" element={<DisclaimerPage />} />
          {/* Security is a section of the privacy policy, as on federal sites. */}
          <Route path="/search" element={<SearchPage />} />
          <Route path="/:agency" element={<MissionHomePage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </PrefsProvider>
  )
}
